import { Button as BaseButton } from "@chakra-ui/react";

export default BaseButton;
